
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { Authguard } from './core/auth/auth.guard';
import { expDocAdminGuard } from './core/auth/expdoc-admin.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [Authguard],
    canMatch: [Authguard],
    pathMatch: 'full'
  },
  {
    path: 'access',
    loadChildren: () => import('./settings/access/access.module').then(m => m.AccessModule),
    canActivate: [Authguard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  {
    path: 'approve',
    loadChildren: () => import('./shipment/approve/approve.module').then(m => m.ApproveModule),
    canActivate: [Authguard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  {
    path: 'binary',
    loadChildren: () => import('./shipment/binary/binary.module').then(m => m.BinaryModule),
    canActivate: [Authguard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  {
    path: 'notifications-config',
    loadChildren: () => import('./settings/notifications/notifications-config/notifications-config.module').then(m => m.NotificationsConfigModule),
    canActivate: [Authguard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  {
    path: 'notifications-details/notificationsdetails',
    loadChildren: () => import('./settings/notifications/notifications-config/notifications-details/notifications-details.module').then(m => m.NotificationsDetailsModule),
    canActivate: [Authguard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  { path: 'artifacts', loadChildren: () => import('./shipment/artifacts/artifacts.module').then(m => m.ArtifactsModule), canActivate: [Authguard], canMatch: [Authguard], data: { authGuard: { redirect: '/login' } } },
  { path: 'notifications-categories', loadChildren: () => import('./settings/notifications/notifications-categories/notifications-categories.module').then(m => m.NotificationsCategoriesModule), canActivate: [Authguard], canMatch: [Authguard], data: { authGuard: { redirect: '/login' } } },
  { path: 'cd', loadChildren: () => import('./cd/cd.module').then(m => m.CdModule), canActivate: [Authguard], canMatch: [Authguard], data: { authGuard: { redirect: '/login' } } },
  { path: 'atusx/new-package-dic', loadChildren: () => import('./atusx/new-package-dic/new-package-dic.module').then(m => m.NewPackageDicModule), canActivate: [Authguard], canMatch: [Authguard], data: { authGuard: { redirect: '/login' } } },
  { path: 'atusx/package-admin', loadChildren: () => import('./atusx/package-admin/package-admin.module').then(m => m.PackageAdminModule), canActivate: [Authguard], canMatch: [Authguard], data: { authGuard: { redirect: '/login' } } },
  {
    path: 'manifest',
    canActivate: [Authguard],
    canActivateChild: [Authguard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } },
    children: [
      {
        path: '',
        loadComponent: () => import('./manifest/list/manifest-list.component').then(m => m.ManifestListComponent)
      },
      {
        path: 'base-de-dados',
        loadComponent: () => import('./manifest/client-detail/manifest-client-detail.component').then(m => m.ManifestClientDetailComponent)
      },
      {
        path: 'bases',
        loadComponent: () => import('./manifest/clients/manifest-clients.component').then(m => m.ManifestClientsComponent)
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./manifest/dashboard/manifest-dashboard.component').then(m => m.ManifestDashboardComponent)
      }
    ]
  },
  {
    path: 'manifest-admin',
    loadChildren: () => import('./manifest-admin/manifest-admin.module').then(m => m.ManifestAdminModule),
    canActivate: [Authguard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  {
    // Documentação da Expedição Contínua. O expDocAdminGuard soma-se ao
    // Authguard: este trata a ausência de sessão, aquele restringe ao grupo
    // Admin, porque menu oculto não é controle de acesso.
    path: 'expedition/doc-approval',
    loadComponent: () => import('./shipment/documentation/approval/doc-approval.component').then(m => m.DocApprovalComponent),
    canActivate: [Authguard, expDocAdminGuard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  {
    path: 'expedition/doc-generation',
    loadComponent: () => import('./shipment/documentation/generation/doc-generation.component').then(m => m.DocGenerationComponent),
    canActivate: [Authguard, expDocAdminGuard],
    canMatch: [Authguard],
    data: { authGuard: { redirect: '/login' } }
  },
  {
    path: '**',
    redirectTo: '/login'
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
